import 'css-chunksrc/client/common/secondaryCriteriaForm/documentForm/fileInput/styles.scss';export default {
  "fileInput": "_fileInput_1sesm_1",
  "icon": "_icon_1sesm_15",
  "input": "_input_1sesm_25"
};